import { TextCodes } from '@api/types/translation/TextCodes';
import { Button, Title, useDealerDetailsContext } from '@components';
import { Box, Divider, styled } from '@mui/material';
import { t } from '@translations';

const DealerHeaderWrapper = styled(Box)``;

type DealerDetailsHeaderProps = {
  title?: string;
  contentLinkId?: number;
};

export const DealerDetailsHeader = ({ title, contentLinkId }: DealerDetailsHeaderProps) => {
  const { toggleEditDataState, isAuth, canEditData } = useDealerDetailsContext();
  const handleEdit = () => {
    toggleEditDataState(true);
    const element = document.getElementById(`dealer-details-form-${contentLinkId}`);
    element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };
  return (
    <DealerHeaderWrapper>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: {
            sm: 'flex-end',
          },
          flexDirection: {
            xs: 'column',
            sm: 'row',
          },
        }}
      >
        <Title
          variant='h1'
          sx={{
            marginBottom: {
              sm: -2,
              md: -3,
            },
          }}
        >
          {title || t(TextCodes.Dealer.Details.ShopDetails)}
        </Title>
        {isAuth && !canEditData && (
          <Button variant='ghost' onClick={handleEdit}>
            {t(TextCodes.Base.Edit)}
          </Button>
        )}
      </Box>

      <Divider sx={{ mt: 1, mb: 4 }} />
    </DealerHeaderWrapper>
  );
};
